import { NoticeTypes } from '@genial/components';

import { PublicOfferDetailsModalityWithTimelineNormalized } from '../../../../../../../../store/product/types';

export const getDisabledReason = (
  selectedModality: PublicOfferDetailsModalityWithTimelineNormalized | undefined,
  managerDidNotAcceptTerms: boolean
) => {
  if (!selectedModality) {
    return 'Nenhuma modalidade selecionada';
  }

  if (selectedModality.isExpired) {
    return 'Produto Expirado';
  }

  if (managerDidNotAcceptTerms) {
    return 'Gestor não declarou ciência';
  }

  return '';
};

export const managerNoticeTexts: NoticeTypes.Props['textObjects'] = [
  {
    text: 'Atenção: ',
    variant: 'semibold',
  },
  {
    text: 'Declaro que recebi, li e estou de acordo com o termo de adesão e ciência de risco do produto investido.',
    variant: 'regular',
  },
];
